import {
  Bell,
  BookOpen,
  Briefcase,
  Building2,
  ClipboardList,
  Clock,
  FileText,
  FolderOpen,
  Home,
  LayoutTemplate,
  ListChecks,
  MessageSquare,
  Package,
  Scale,
  ScrollText,
  User,
  type LucideIcon
} from "lucide-react";

import type { EntityKind } from "../refs/entityRefs";

const ICONS: Record<EntityKind, LucideIcon> = {
  practice: Home,
  client: User,
  case: Briefcase,
  document: FileText,
  record: ScrollText,
  reminder: Bell,
  intake: ClipboardList,
  template: LayoutTemplate,
  draft: FileText,
  file: FolderOpen,
  form: FileText,
  packet: Package,
  plan: ListChecks,
  thread: MessageSquare,
  library: BookOpen,
  company: Building2,
  rule: Scale,
  time_entry: Clock
};

/** The icon the composer chip and the turn's context line show for a kind. */
export const onScreenIcon = (kind: EntityKind): LucideIcon => ICONS[kind];
